const Component = () => import('./Component');

export { Component };
